import { render, staticRenderFns } from "./TireDialogTabsExpansionTable.vue?vue&type=template&id=af34d03a&"
import script from "./TireDialogTabsExpansionTable.vue?vue&type=script&lang=js&"
export * from "./TireDialogTabsExpansionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports